import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import IRole from '../../../app/_interfaces/IRole';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<IRole[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/roles`
    );
  }

  get(customers_id: number, roles_id: number) {
    return this.http.get<IRole>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/${roles_id}`
    );
  }

  create(customers_id: number, role: IRole) {
    return this.http.post(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/`,
      role
    );
  }

  update(customers_id: number, roles_id: number, role: IRole) {
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/${roles_id}`,
      role
    );
  }

  delete(customers_id: number, roles_id: number) {
    return this.http.delete(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/${roles_id}`
    );
  }

  updatePermissions(
    customers_id: number,
    roles_id: number,
    resources_id: number,
    action: string,
    value: boolean
  ) {
    const update = {
      resources_id,
      action,
      value,
    };
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/${roles_id}/permissions`,
      update
    );
  }

  updateWidget(
    customers_id: number,
    roles_id: number,
    widgets_id: number,
    value: boolean
  ) {
    const update = {
      widgets_id,
      value,
    };
    return this.http.patch(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles/${roles_id}/widgets`,
      update
    );
  }

  getByCustomer(customers_id: number) {
    return this.http.get<IRole[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/roles`,
      {}
    );
  }
}
